import React from 'react';
import { connect } from 'react-redux';
import history from '../../utils/history';
import logo from '../../images/billsby-logo.svg';
import './Header.scss';
import { AppState } from '../..';
import { IAuthReducerState } from '../../reducers/authReducer';

interface IHeader {
  authData: IAuthReducerState,
  dispatch: Function
}


const Header: React.FC<IHeader> = ({ authData, dispatch }) => {

  const { parsedToken } = authData;

  if (!parsedToken) {
    return (
      <div className="header">
        <div className="header__logo">
          <img src={logo} alt="Billsby Logo" onClick={() => history.push("/login")} />
        </div>
      </div>
    )
  }

  return null;
}

export default connect((state: AppState) => ({ authData: state.auth }))(Header);